<template>
  <tr :class="{ 'is-hidden': listItem.hidden }">
    <td v-if="isAttachmentMode" class="px-3 doc-check">
      <v-checkbox v-model="listItem.selected" :disabled="disabledSelection" primary hide-details
        v-if="listItem.type !== 'folder'" color="secondary" @change="toggleFileSelection(listItem)"></v-checkbox>
    </td>
    <td class="doc-primary-td text-truncate">
      <v-flex>
        <font-awesome-icon size="2x" :icon="['far', listItem.icon]" class="secondary--text mr-3"></font-awesome-icon>
        <h3 class="d-inline-block"><a href="" @click.prevent="getFile(false)">{{ listItem.name }}</a></h3>
      </v-flex>
      <v-menu v-if="!isAttachmentMode" nudge-top="40px" right offset-y transition="scale-transition">
        <v-btn flat slot="activator" icon class="ma-0 pa-0" dark color="secondary">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list dense>
          <v-list-tile v-if="isAttachmentViewable()" @click="viewFileToSide()">
            <!-- ony show if openable -->
            <v-icon class="mr-2" color="secondary">vertical_split</v-icon>
            Open to the side
          </v-list-tile>
          <v-list-tile v-if="isAttachmentViewable()" @click="getFile(false)">
            <!-- ony show if openable -->
            <v-icon class="mr-2" color="secondary">open_in_browser</v-icon>
            Open in new tab
          </v-list-tile>
          <v-list-tile @click="openFileDialog('setDuplicateFileDialog', listItem)">
            <v-icon class="mr-2" color="secondary">content_copy</v-icon>
            Duplicate
          </v-list-tile>
          <v-list-tile @click="getFile(true)">
            <v-icon class="mr-2" color="secondary">file_download</v-icon>Download
          </v-list-tile>
          <v-list-tile @click="openFileDialog('setMoveFileDialog', listItem)">
            <v-icon class="mr-2" color="secondary">drive_file_move_outline</v-icon>Move to
          </v-list-tile>
          <v-list-tile @click="openFileDialog('setCopyFileDialog', listItem)">
            <v-icon class="mr-2" color="secondary">content_copy</v-icon>
            Copy to
          </v-list-tile>
          <v-list-tile v-if="!listItem.hidden" href="#" @click="hideFile">
            <font-awesome-icon :icon="['fas', 'eye-slash']" class="mr-2"></font-awesome-icon>Hide</v-list-tile>
          <v-list-tile v-if="listItem.hidden" href="#" @click="showFile">
            <font-awesome-icon :icon="['fas', 'eye']" class="mr-2"></font-awesome-icon>Unhide</v-list-tile>
          <v-list-tile @click="openFileDialog('setRenameFileDialog', listItem)">
            <v-icon class="mr-2" color="secondary">drive_file_rename_outline</v-icon>Rename
          </v-list-tile>
          <v-list-tile @click="openFileDialog('setDeleteFileDialog', listItem)">
            <v-icon class="mr-2" color="error">delete</v-icon>Delete</v-list-tile>
        </v-list>
      </v-menu>
    </td>
    <td v-if="displayColumn('date')" class="text-truncate">{{ formatDate(listItem.date) }}</td>
    <td v-if="displayColumn('size')" class="text-truncate">{{ listItem.size }}</td>
    <td v-if="displayColumn('modified')" class="text-truncate">{{ listItem.modified || '-' }}</td>
  </tr>
</template>

<script>
import Helpers from '@/helpers.js'
import { mapState } from "vuex"

export default {
  name: "file-list-item",
  props: ['listItem', 'documentHeaders', 'isAttachmentMode', 'allowSelectMultiple'],
  computed: {
    ...mapState({
      currentAccount: state => state.currentUser.account,
      currentCase: state =>
        state && state.cases && state.cases.currentlySelected.case
          ? state.cases.currentlySelected.case
          : {},
      currentCaseType: state => state.caseTypes.current,
      userPreferences: state => state.currentUser.me.preferences,
      selectedAttachments: state => state.folders.selectedAttachments
    }),
    disabledSelection() {
      return !this.listItem.selected && !this.allowSelectMultiple && this.selectedAttachments.length > 0
    }
  },
  methods: {
    async hideFile() {
      console.log("hiding file", this.listItem)
      const fileAttachment = await this.$store.dispatch("hideFileAttachment", this.listItem)
      console.log("fileAttachment", fileAttachment)
      this.$store.dispatch("updateCaseFileAttachment", fileAttachment)
    },
    showFile() {
      console.log("showing file", this.listItem)
      this.$store.dispatch("showFileAttachment", this.listItem)
    },
    displayColumn(column) {
      if (!this.documentHeaders) return false
      return this.documentHeaders.find(header => header.value === column)
    },
    formatDate(date) {
      if (this.userPreferences.dateTimeFormat) {
        return Helpers.formatDate(date, this.userPreferences.dateTimeFormat)
      } else {
        return Helpers.formatDate(date, "Do MMM YYYY HH:mm")
      }
    },
    async getFile(download = false) {
      try {
        const query = (download) ? '?isDownload=true' : ''
        const url = window.location.href.startsWith("http://localhost") ? `http://localhost:6543${this.listItem.url}${query}` : `${this.listItem.url}${query}`
        const auth = 'Bearer ' + window.localStorage.session

        const anchor = document.createElement("a")
        document.body.appendChild(anchor)
        const headers = new Headers()
        headers.append("Authorization", auth)

        const response = await fetch(url, { headers })
        const blobby = await response.blob()
        const objectUrl = window.URL.createObjectURL(blobby)
        anchor.href = objectUrl
        if (download) {
          anchor.download = this.listItem.name
        } else {
          anchor.target = "blank"
        }
        anchor.click()
      } catch (err) {
        console.log(err)
        this.$store.commit("displayFlashMessage", { message: `Failed to view/download file `, severity: "error" })
      }
    },
    isAttachmentViewable() {
      const types = ['application/pdf', 'image/*']
      if (this.listItem && this.listItem.contentType) {
        const viewable = types.find(t => this.listItem.contentType.search(t))
        if (viewable !== -1) return true
      }
      return false
    },
    viewFileToSide() {
      if (this.listItem) {
        const formattedFileAttachment = Object.assign({}, this.listItem)
        formattedFileAttachment.filename = formattedFileAttachment.name
        formattedFileAttachment.updatedAt = formattedFileAttachment.date
        this.$store.dispatch('viewFileToSide', { field: { name: formattedFileAttachment.name }, fileAttachment: formattedFileAttachment })
      }
    },
    openFileDialog(action, file) {
      this.$store.dispatch(action, { dialogState: true, file })
    },
    toggleFileSelection(file) {
      if (file && file.id) {
        this.$store.dispatch('toggleFileSelection', { file, allowSelectMultiple: this.allowSelectMultiple })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.svg-inline--fa {
  font-size: 1.4em;
}

.is-hidden {
  opacity: 0.4;
}
</style>